import React, { useState } from 'react';
import { Card } from './ui/Card';
import { Button } from './ui/Button';
import { ZoomInIcon, ZoomOutIcon, MapPinIcon, SearchIcon, DownloadIcon } from 'lucide-react';
import { useEvent } from '../contexts/EventContext';
export function FloorPlan() {
  const {
    currentEvent,
    isOnline
  } = useEvent();
  const [zoom, setZoom] = useState(1);
  const [selectedStand, setSelectedStand] = useState<string | null>(null);
  const stands = [{
    id: 'A12',
    name: 'FitTech Pro',
    x: 20,
    y: 20,
    category: 'Equipment'
  }, {
    id: 'B05',
    name: 'NutriMax',
    x: 50,
    y: 30,
    category: 'Nutrition'
  }, {
    id: 'C18',
    name: 'ActiveWear',
    x: 70,
    y: 50,
    category: 'Apparel'
  }, {
    id: 'D22',
    name: 'Recovery Zone',
    x: 30,
    y: 60,
    category: 'Wellness'
  }];
  return <div className="pb-24" data-id="element-3507">
      {/* Controls - adjusted sticky position */}
      <div className="sticky top-[88px] z-30 bg-white border-b border-gray-200 p-4" data-id="element-3508">
        <div className="flex items-center justify-between gap-3 mb-3" data-id="element-3509">
          <div className="flex gap-2" data-id="element-3510">
            <button onClick={() => setZoom(Math.max(0.5, zoom - 0.25))} className="p-2 rounded-lg bg-gray-100 hover:bg-gray-200 transition-colors" data-id="element-3511">
              <ZoomOutIcon className="w-5 h-5 text-gray-700" data-id="element-3512" />
            </button>
            <button onClick={() => setZoom(Math.min(2, zoom + 0.25))} className="p-2 rounded-lg bg-gray-100 hover:bg-gray-200 transition-colors" data-id="element-3513">
              <ZoomInIcon className="w-5 h-5 text-gray-700" data-id="element-3514" />
            </button>
          </div>
        </div>

        {!isOnline && <div className="bg-orange-50 border border-orange-200 rounded-lg p-3 flex items-start gap-2" data-id="element-3515">
            <MapPinIcon className="w-5 h-5 text-orange-600 flex-shrink-0 mt-0.5" data-id="element-3516" />
            <div data-id="element-3517">
              <p className="text-sm font-medium text-orange-900 font-gotham" data-id="element-3518">
                Offline Mode
              </p>
              <p className="text-xs text-orange-700 font-gotham" data-id="element-3519">
                Using cached floor plan
              </p>
            </div>
          </div>}
      </div>

      {/* Map Container */}
      <div className="relative bg-gray-100 overflow-auto" style={{
      height: '70vh'
    }} data-id="element-3520">
        <div className="transition-transform duration-300 origin-top-left" style={{
        transform: `scale(${zoom})`,
        transformOrigin: 'top left'
      }} data-id="element-3521">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/4LUxs35aBDoS78x1BNsGAQ/Floorplan.jpg" alt="Event Floor Plan" className="w-full h-auto" style={{
          maxWidth: 'none'
        }} data-id="element-3522" />
        </div>
      </div>

      {/* Legend */}
      <div className="px-4 py-4 bg-white border-t border-gray-200" data-id="element-3523">
        <h3 className="text-sm font-semibold text-gray-900 mb-3 font-gotham" data-id="element-3524">
          Legend
        </h3>
        <div className="grid grid-cols-2 gap-3" data-id="element-3525">
          <div className="flex items-center gap-2" data-id="element-3526">
            <div className="w-4 h-4 rounded bg-red-600" data-id="element-3527" />
            <span className="text-sm text-gray-700 font-gotham" data-id="element-3528">
              Bodybuilding Backstage Area
            </span>
          </div>
          <div className="flex items-center gap-2" data-id="element-3529">
            <div className="w-4 h-4 rounded bg-teal-400" data-id="element-3530" />
            <span className="text-sm text-gray-700 font-gotham" data-id="element-3531">
              Main Fitness Stage
            </span>
          </div>
          <div className="flex items-center gap-2" data-id="element-3532">
            <div className="w-4 h-4 rounded bg-sky-400" data-id="element-3533" />
            <span className="text-sm text-gray-700 font-gotham" data-id="element-3534">
              Padel Zone & Active Arena
            </span>
          </div>
          <div className="flex items-center gap-2" data-id="element-3535">
            <div className="w-4 h-4 rounded bg-slate-700" data-id="element-3536" />
            <span className="text-sm text-gray-700 font-gotham" data-id="element-3537">
              Exhibitor Stands
            </span>
          </div>
        </div>
      </div>

      {/* Download Option */}
      <div className="px-4 pb-4" data-id="element-3538">
        <button className="w-full flex items-center justify-center gap-2 p-3 rounded-lg border-2 font-medium font-gotham transition-all hover:bg-opacity-5" style={{
        borderColor: currentEvent.colors.primary,
        color: currentEvent.colors.primary
      }} data-id="element-3539">
          <DownloadIcon className="w-5 h-5" data-id="element-3540" />
          Download Floor Plan
        </button>
      </div>
    </div>;
}